;
define("error_management_logged_out.tpl", function(){});

